import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Card,
  CardContent,
  Stack,
  Typography,
} from "@mui/material";
import StepLayout from "../../components/StepLayout/StepLayout";
import { useTunnelDispatch, useTunnelState } from "../../context/TunnelContext";
import { connectPrinter, getAuthorizedPrinter, sendToPrinter } from "../../utils/printer";

function buildTicketHtml(tickets) {
  const ticketLines = tickets
    .map(({ shoe, number }, index) => {
      const brand = shoe?.brand || "Marque inconnue";
      const model = shoe?.model ? ` — ${shoe.model}` : "";
      const size = shoe?.size ? ` — pointure ${shoe.size}` : "";

      return `
        <div class="ticket-item">
          <div class="ticket-number">${number}</div>
          <div class="ticket-details">${brand}${model}${size}</div>
        </div>
      `;
    })
    .join("");

  return `
    <!doctype html>
    <html>
      <head>
        <meta charset="utf-8" />
        <title>Tickets Web Climbing</title>
        <style>
          body {
            font-family: Arial, sans-serif;
            margin: 0;
            padding: 24px;
            color: #111;
            background: #fff;
          }
          .wrapper {
            width: 320px;
            margin: 0 auto;
          }
          .title {
            font-size: 18px;
            font-weight: 700;
            text-align: center;
            margin-bottom: 16px;
          }
          .ticket-item {
            border: 1px solid #ddd;
            border-radius: 6px;
            padding: 12px;
            margin-bottom: 10px;
          }
          .ticket-number {
            font-size: 24px;
            font-weight: 700;
            margin-bottom: 6px;
          }
          .ticket-details {
            font-size: 13px;
            line-height: 1.4;
          }
        </style>
      </head>
      <body>
        <div class="wrapper">
          <div class="title">Web Climbing</div>
          ${ticketLines}
        </div>
      </body>
    </html>
  `;
}

export default function TicketScreen() {
  const navigate = useNavigate();
  const dispatch = useTunnelDispatch();
  const { tickets } = useTunnelState();

  useEffect(() => {
    if (tickets.length === 0) {
      navigate("/nouvelle-demande/marque", { replace: true });
      return;
    }
    connectPrinter().then((device) => {
      if (!device) {
        console.warn("No printer connected.");
        return;
      }
      getAuthorizedPrinter().then((device) => {
        if (!device) {
          console.warn("No authorized printer found.");
          return;
        }

        sendToPrinter(device).catch((error) => {
          console.error("Error sending to printer:", error);
        });
      });
    });

    // const printWindow = window.open('', '_blank', 'width=400,height=600');

    // if (!printWindow) {
    //   window.print();
    //   return;
    // }

    // printWindow.document.write(buildTicketHtml(tickets));
    // printWindow.document.close();
    // printWindow.focus();

    // window.setTimeout(() => {
    //   printWindow.print();
    //   printWindow.close();
    // }, 250);
  }, [navigate, tickets]);

  function handleDone() {
    dispatch({ type: "RESET_ORDER" });
    navigate("/");
  }

  return (
    <StepLayout title="Vos tickets" onBack={handleDone}>
      <Typography sx={{ mb: 3 }}>
        Merci de déposer chaque paire de chaussons dans la boîte dédiée, avec
        son numéro de ticket.
      </Typography>
      <Stack spacing={2} sx={{ maxWidth: 480, mb: 4 }}>
        {tickets.map(({ shoe, number }, index) => (
          <Card key={index} variant="outlined">
            <CardContent>
              <Typography variant="h5">{number}</Typography>
              <Typography variant="body2" color="text.secondary">
                {shoe.brand}
                {shoe.model ? ` — ${shoe.model}` : ""} — pointure {shoe.size}
              </Typography>
            </CardContent>
          </Card>
        ))}
      </Stack>

      <Typography variant="subtitle1" sx={{ maxWidth: 480, mb: 1 }}>
        Et maintenant ?
      </Typography>
      <Box
        component="ol"
        sx={{ maxWidth: 480, mb: 4, pl: 3, color: "text.secondary" }}
      >
        <Typography component="li" variant="body2" sx={{ mb: 1 }}>
          Vos chaussons seront envoyés à l'atelier.
        </Typography>
        <Typography component="li" variant="body2" sx={{ mb: 1 }}>
          Un lien de paiement vous sera envoyé une fois vos chaussons vérifiés
          par l'atelier.
        </Typography>
        <Typography component="li" variant="body2" sx={{ mb: 1 }}>
          L'atelier procédera aux réparations une fois le paiement effectué.
        </Typography>
        <Typography component="li" variant="body2">
          Vos chaussons seront réexpédiés à votre salle d'escalade une fois les
          réparations terminées.
        </Typography>
      </Box>

      <Button variant="contained" size="large" onClick={handleDone}>
        Terminer
      </Button>
    </StepLayout>
  );
}
